import { render } from "./add-rank-dialog.vue?vue&type=template&id=17af6dcc&scoped=true"
import script from "./add-rank-dialog.vue?vue&type=script&lang=js"
export * from "./add-rank-dialog.vue?vue&type=script&lang=js"

import "./add-rank-dialog.vue?vue&type=style&index=0&id=17af6dcc&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17af6dcc"]])

export default __exports__